import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CheckinsAccessService } from './checkins-access.service';

/**
 * Guards the event-management routes (create/edit). Pair it *after* authGuard, which guarantees a
 * signed-in user; this only checks the Checkins Admin role. Non-admins are bounced back to the
 * events list with the same message the API would return. The API still enforces this on its own.
 */
export const adminGuard: CanActivateFn = () => {
  const access = inject(CheckinsAccessService);
  const router = inject(Router);

  if (access.isAdmin()) {
    return true;
  }

  inject(ToastrService).error("You don't have permission to do that.");
  return router.createUrlTree(['/events']);
};
